import React from "react";

// SOESO-FULFIL-01 · STOCK badge derived from the existing stock classification (order_against).
export const FULFILMENT_LABEL = {
  production_sales: "Production + Sales",
  stock_only: "Stock Only — No Sales",
  sales_only: "Sales Only — No Production",
};

export const fulfilmentOf = (o) =>
  (o?.order_against || "") === "stock" ? "stock_only" : o?.fulfilment_mode === "sales_only" ? "sales_only" : "production_sales";

export const isStockOrder = (o) => (o?.order_against || "") === "stock";

export const StockBadge = ({ testId }) => (
  <span data-testid={testId} title="Against Stock · Stock Only — No Sales"
    className="inline-flex items-center px-1.5 py-0.5 rounded-sm text-[9px] font-mono font-bold uppercase tracking-widest bg-emerald-500/15 text-emerald-400 border border-emerald-500/30 shrink-0">
    STOCK
  </span>
);

export const OrderRef = ({ no, stock, testId, className = "" }) => (
  <span className={`inline-flex items-center gap-1 whitespace-nowrap ${className}`} data-testid={testId}>
    <span>{no || "—"}</span>
    {stock && <><span className="text-zinc-500">·</span><StockBadge testId={testId ? `${testId}-stock` : undefined} /></>}
  </span>
);

export const FulfilmentChoice = ({ value, onChange, disabled, prefix }) => (
  <div className="flex items-center gap-2" data-testid={`${prefix}-fulfilment`}>
    <span className="text-[10px] uppercase tracking-widest text-zinc-500">Fulfilment</span>
    <div className="inline-flex border border-[var(--border)] rounded-sm overflow-hidden">
      {[["production_sales", "Production + Sales"], ["sales_only", "Sales Only"]].map(([k, l]) => (
        <button key={k} type="button" disabled={disabled} data-testid={`${prefix}-fulfilment-${k}`}
          onClick={() => onChange(k)}
          className={`px-3 h-8 text-[11px] font-medium uppercase tracking-widest border-r border-[var(--border)] last:border-r-0 disabled:opacity-50 ${(value || "production_sales") === k ? "bg-[var(--accent)] text-white" : "text-zinc-400 hover:bg-[var(--bg-2)]"}`}>
          {l}
        </button>
      ))}
    </div>
    {value === "sales_only" && <span className="text-[10px] text-amber-300">No WO · packs picked from FG Store</span>}
  </div>
);

// STOCK-PACK-01 · Pack Against → Stock pickers (eligible, authorised Stock SO/ESO + exact line).
const CLOSED = ["cancelled", "hold", "on hold", "short closed", "closed", "completed"];
export const isEligibleStockOrder = (o, isExport) =>
  isStockOrder(o) && !o?.on_hold && !CLOSED.includes(String(o?.status || "").toLowerCase()) &&
  (isExport ? String(o?.auth_status || "").toLowerCase() === "authorised" : o?.authorized === true);

export const stockLinesOf = (o, isExport) => (o?.items || []).map((li, i) => ({
  line_id: isExport ? (li.line_id || String(i)) : (li.line_id || li.id || String(i)),
  line_no: i + 1,
  item_id: isExport ? (li.article_no || "") : (li.article_id || li.item_id || li.article_no || ""),
  code: li.article_no || li.product_code || li.item_code || "",
  style_no: li.style_no || "",
  qty: Number(li.order_qty ?? li.qty ?? li.quantity ?? 0),
  closed: !!(li.short_closed || li.cancelled_at),
})).filter(l => !l.closed && l.code);
